import { adminVerificationQueryKeys as e } from "./adminVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/admin/useResyncIdentityVerificationMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ userId: e, override: t }) => r.adminResyncIdentityVerification(e, t),
		retry: !1,
		onSuccess: (t, { userId: n }) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.stats() }), i.invalidateQueries({ queryKey: e.detail("identity", n) });
		}
	});
};
//#endregion
export { i as useResyncIdentityVerificationMutation };
